import React from "react";
import { Check } from "lucide-react";

const Checkbox = ({ checked, onChange, classes, size = 16 }) => {
    const checkboxSize = `${size}px`;
    const iconSize = size - 6;

    return (
        <label className={`flex items-center hover:cursor-pointer ${classes}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                className="peer hidden"
            />
            <div
                className="rounded border-2
                   border-gray-300 bg-white
                   dark:border-neutral-700 dark:bg-neutral-800
                   peer-checked:bg-blue-600 peer-checked:border-blue-600
                   dark:peer-checked:bg-blue-500 dark:peer-checked:border-blue-500
                   transition-colors duration-200 flex items-center justify-center"
                style={{ width: checkboxSize, height: checkboxSize }}
            >
                {checked && <Check size={iconSize} strokeWidth={2} className="text-white" />}
            </div>
        </label>
    );
}

export default Checkbox;